import { render } from "./Column202405.vue?vue&type=template&id=41274368&scoped=true"
import script from "./Column202405.vue?vue&type=script&lang=js"
export * from "./Column202405.vue?vue&type=script&lang=js"

import "./Column202405.vue?vue&type=style&index=0&id=41274368&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41274368"

export default script